<!-- 由 suu 创建于 2025-01-03 星期五 -->
<!-- 获取教练信息跳转预约教练课程 -->
<template>
  <div class="trans-coach-course">
    <img :src="defaultImg" />
  </div>
</template>

<script>
export default {
  name: 'trans-coach-course',

  components: {},

  props: {},

  data() {
    return {
      defaultImg: 'https://cdnvue.gymcity.com.cn/uploads/loading-member',
      coachid: this.$route.query.coachid,
      day: this.$route.query.day,
      autoShowCircle: this.$route.query.autoShowCircle
    }
  },

  computed: {},

  watch: {},

  created() {
    if (!this.coachid) {
      this.$toast('请传入教练id')
      return
    }
    if (this.day && this.day.indexOf('-') < 0) {
      this.$toast('日期格式传入错误')
      return
    }
    this.goClass()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 约课
    goClass() {
      // 获取教练信息
      let params = {
        a: 'coachCard',
        cid: this.coachid
      }
      // this.$toast.loading('加载中···')
      this.$http
        .get('member/active', params)
        .then((rs) => {
          // this.$toast.clear()
          if (rs.data.code === 200 && rs.data.data) {
            this.toDetail(this.coachid, rs.data.data)
          } else {
            this.$dialog({ message: `教练信息获取失败：${rs.data.msg}` })
          }
        })
        .catch((err) => {
          this.$dialog({ message: '网络错误' })
          // this.$toast.clear()
        })
    },
    /**
     * 自主约课 跳转教练排课详情
     * @param cid 教练ID
     * @param obj 教练信息
     */
    toDetail(cid, obj) {
      let detailData = obj
      let currDay = this._getCurDay()
      // 教练详情默认请求此日期的排课信息
      detailData['coursetime'] = currDay
      if (Object.keys(detailData).length > 0) {
        this.$store.commit('setDetailData', detailData)
        this.$store.commit('setCurrDay', currDay)
        if (this.autoShowCircle) {
          sessionStorage['autoShowCircle'] = 1
        }
        this.$router.replace({
          path: '/subscribe/detail',
          query: {
            day: this.day
          }
        })
      }
    },
    //  * 获取当日 格式
    _getCurDay() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = this.day ? new Date(this.day.replace(/-/g, '/')) : new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + day,
        week: week[date.getDay()]
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.trans-coach-course {
  background: #f7f7f7;
  position: absolute;
  z-index: 1900;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  & > img {
    width: 100%;
    height: auto;
  }
}
</style>
